<template>
  <section class="agenda monday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Pre-Registration
            </h1>
          </div>
        </div>
      </div>
      <div class="cards__container">
        <div class="cards__single gray noheight">
          <p class="cards__title">
            Pre - Registration
          </p>
          <div class="cards__description">
            <p>4:00 PM - 7:00 PM</p>
          </div>
          <div class="cards__location">
            @ Patio del Fauno
          </div>
        </div>
        <div class="cards__single green">
          <p class="cards__title">
            Welcome Happy Hour Brought by Chardan
          </p>
          <div class="cards__description">
            <p>5:00 PM - 7:00 PM</p>
          </div>
          <div class="cards__location">
            @ West Veranda, Condado Vanderbilt
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda/style.scss';
  @import '@/styles/components/agenda/agenda.scss';
  @import '@/styles/components/agenda/dayone.scss';
</style>

<script>
export default {
  name: 'Day One'
};
</script>